import { render, staticRenderFns } from "./ConfiguracoesSeguranca.vue?vue&type=template&id=0b3eb95e"
import script from "./ConfiguracoesSeguranca.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesSeguranca.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracoesSeguranca.vue?vue&type=style&index=0&id=0b3eb95e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports